import type { LabelValue } from "newui/types/LabelValue.type";
import type { CommonLookupResponse } from "newui/store/tanstack-base";
import { useCommonLookup } from "newui/store/tanstack-base";
import { fetchTrades } from "../company-api";

export const useTrades = (): CommonLookupResponse<LabelValue<number>> =>
	useCommonLookup<LabelValue<number>>("trades", fetchTrades);
